// デモデータ（同梱サンプル）表示 ON/OFF の設定ローダー（2026-08-27・案C / OPEN-DECISIONS #17）。
// 設定の持ち方は settings/labor（laborRates.js・#53）と同じ流儀＝Supabase の設定ドキュメント1件。
// ドキュメント: settings/display { demoData: boolean, updatedAt }。UI はダッシュボードの「表示設定」パネル。
//
// 起動時に main.js が refreshDemoSetting(true) で先読みする。ビューが描かれる前に確定させることで
// 「設定が届く前に一瞬サンプルが出る」競合を作らない。読めていない間の既定は OFF＝サンプルを出さない安全側。
import { COLLECTIONS, getOne, upsert } from './collections.js'
import { supabaseReady } from '../supabase.js'
import { DEMO_DEFAULT_ON, resolveDemoOn, allowSample as coreAllowSample } from './demoData.core.js'

let _on = DEMO_DEFAULT_ON
let _loaded = false

// 現在の設定値（同期）。ビューは描画のたびにこれを見る。
export function isDemoDataOn() { return _on }
export function demoSettingLoaded() { return _loaded }

// 設定ドキュメントの読取（無ければ既定 OFF）。失敗しても既定 OFF に倒す。
export async function loadDemoSetting() {
  if (!supabaseReady) return DEMO_DEFAULT_ON
  try { return resolveDemoOn(await getOne(COLLECTIONS.settings, 'display')) }
  catch { return DEMO_DEFAULT_ON }
}

// 起動時の先読み（main.js）。force で再取得。
export async function refreshDemoSetting(force) {
  if (_loaded && !force) return _on
  _on = await loadDemoSetting()
  _loaded = true
  return _on
}

// 設定の保存（ダッシュボードの表示設定パネルから）。保存後は各ビューの再描画で即反映される。
export async function saveDemoSetting(on) {
  const next = on === true
  if (supabaseReady) await upsert(COLLECTIONS.settings, 'display', { demoData: next, updatedAt: new Date().toISOString() })
  _on = next
  _loaded = true
  return _on
}

// 全ビュー共通の唯一の判定（各ビューに条件を撒かない）。実データ0件でサンプルを描いてよいか。
export function allowSample(online) { return coreAllowSample(online, _on) }

export { DEMO_TAG, noDataHtml, DEMO_DEFAULT_ON } from './demoData.core.js'
